import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'BKButton',
  props: {
    whiteText: { type: Boolean, default: false },
    to: { default: null },
    outlined: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    color: { default: 'var(--color-blue-800)' },
    height: { default: '52' },
    width: { default: '100%' },
    text: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    href: { default: null }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', value: Event): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit }
}

})